<template id="filter-sources-wrapper">
  <div class="px-6 py-4 border-t border-grey-lighter lg:w-1/3 lg:border-l xl:w-full xl:border-l-0">
    <span class="block text-sm font-semibold text-grey-darker">Status bron</span>
    <div class="sm:flex sm:-mx-2 lg:block lg:mx-0">
      <label class="mt-4 sm:w-1/3 sm:px-2 flex items-center lg:w-full lg:px-0" v-for="(filter, index) in items" :key="index">
        <input type="radio" class="form-radio" :name="filter.type" :value="filter.value" @click.prevent="update(filter)" :checked="filter.checked">
        <span class="ml-3 text-grey-darkest">{{ filter.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import { mapState } from 'vuex';

export default {
  template: '#filter-sources-wrapper',
  name: 'FilterSources',
  data() {
    return {
      arrow: 'down',
      items: [
        {
          type: 'inventory_sources_status',
          label: 'Verwijderd',
          value: 'Verwijderd',
          checked: false
        },
        {
          type: 'inventory_sources_status',
          label: 'Aanwezig',
          value: 'Aanwezig|Deels verwijderd',
          checked: false
        },
        {
          type: 'has_asbestos',
          label: 'Geen asbest',
          value: false,
          checked: false
        }
      ]
    };
  },
  created() {
    EventBus.$on('filter-reset', this.reset);
  },
  beforeDestroy() {
    EventBus.$off('filter-reset', this.reset);
  },
  mounted() {
    let selected =
      this.filters['filter[inventory_sources_status]'] ||
      this.filters['filter[has_asbestos]'];

    if (!selected) {
      return this.reset();
    }

    let filter = this.items.find(item => selected.label == item.label);

    if (filter) {
      filter.checked = true;
    }
  },
  computed: {
    ...mapState('subject', {
      filters: state => state.filters
    })
  },
  methods: {
    update(filter) {
      let value = filter.value;

      if (filter.checked) {
        this.reset();
        filter.checked = false;
        value = null;
      } else {
        this.reset();
        filter.checked = true;
      }

      // remove all active source filters.
      this.$store.commit('subject/removeFilter', 'filter[has_asbestos]');
      this.$store.commit(
        'subject/removeFilter',
        'filter[inventory_sources_status]'
      );

      this.$emit('selected', {
        label: filter.label,
        type: filter.type,
        value: value
      });
    },
    reset() {
      this.items.forEach(item => (item.checked = false));
    }
  }
};
</script>
